export default __webpack_public_path__ + "static/appfutura-a6323af256b70ff582bccd4448c3d379.png";